// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const CarouselSlider = ((($) => {
  let slider;
  let options;
  let i;
  function init() {
    slider = $('.Slider-list');
    options = {
      dots: false,
      infinite: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      centerMode: true,
      centerPadding: '160px',
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-subtitle',
      prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            centerMode: false,
            centerPadding: '0',
          }
        }
      ]
    };
    slider.slick(options);
    $('.slider-subtitle').slick({
      dots: false,
      fade: true,
      infinite: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.Slider-list',
      prevArrow: $('.slider-control-prev'),
      nextArrow: $('.slider-control-next'),
    });

    $('.Slider-list').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      $(this);
      nextSlide;
      i = (currentSlide ? currentSlide : 0) + 1;
      $('.current').text(i);
    });

    $('.Slider-list').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      $(this);
      nextSlide;
      i = (currentSlide ? currentSlide : 0) + 1;
      $('.home-slider-pager').text(i + ' / ' + slick.slideCount);
    });
  }
  return {
    init,
  };
}))(jQuery);

export default CarouselSlider;



// WEBPACK FOOTER //
// ./src/static/js/modules/carousel-slider.js